import { useApolloClient } from '@apollo/client';
import { useMutation } from '@zg-rentals/react-query5';
import { useContext } from 'react';
import { ZgGraphContext } from '../contexts/ZgGraphContext';

/**
 * Helper hook to allow calling a graphql query using react-query
 *
 * @param {import('@apollo/client').ApolloClient} apolloClient
 * @param {import('graphql').DocumentNode} mutation
 * @param {import('@zg-rentals/react-query5').UseMutationOptions} mutationOptions
 * @returns {import('@zg-rentals/react-query5').UseMutationResult}
 */
export function useGraphqlMutation(apolloClient, mutation, mutationOptions) {
  return useMutation({
    mutationFn: async (variables) => {
      const { data } = await apolloClient.mutate({ mutation, variables });
      return data;
    },
    ...mutationOptions,
  });
}

/**
 * Helper hook to allow calling a zg-graph graphql mutation using react-query
 *
 * @param {import('graphql').DocumentNode} mutation
 * @param {import('@zg-rentals/react-query5').UseMutationOptions} mutationOptions
 * @returns {import('@zg-rentals/react-query5').UseMutationResult}
 */
export function useZgGraphqlMutation(mutation, mutationOptions) {
  const apolloClient = useContext(ZgGraphContext).client;
  return useGraphqlMutation(apolloClient, mutation, mutationOptions);
}

/**
 * Helper hook to allow calling a zg-graph graphql mutation using react-query
 *
 * @param {import('graphql').DocumentNode} mutation
 * @param {import('@zg-rentals/react-query5').UseMutationOptions} mutationOptions
 * @returns {import('@zg-rentals/react-query5').UseMutationResult}
 */
export function useAlwGraphqlMutation(mutation, mutationOptions) {
  const apolloClient = useApolloClient();
  return useGraphqlMutation(apolloClient, mutation, mutationOptions);
}
